import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllPermohonan = createAsyncThunk(
  "Permohonan/GetAllPermohonan",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}permohonan/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllPermohonanVerifikasi = createAsyncThunk(
  "Permohonan/GetAllPermohonanVerifikasi",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}permohonan/list_verifikasi${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSinglePermohonan = createAsyncThunk(
  "Permohonan/GetSinglePermohonan",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}permohonan/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const PermohonanSlice = createSlice({
  name: "Permohonan",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all permohonan Permohonan
    builder.addCase(GetAllPermohonan.pending, loadingHandler);
    builder.addCase(GetAllPermohonan.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPermohonan.rejected, rejectedHandler);
    // get all permohonan Permohonan by User ID
    builder.addCase(GetAllPermohonanVerifikasi.pending, loadingHandler);
    builder.addCase(GetAllPermohonanVerifikasi.fulfilled, fulfilledHandler);
    builder.addCase(GetAllPermohonanVerifikasi.rejected, rejectedHandler);
    // get Single permohonan Permohonan
    builder.addCase(GetSinglePermohonan.pending, loadingHandler);
    builder.addCase(GetSinglePermohonan.fulfilled, fulfilledHandler);
    builder.addCase(GetSinglePermohonan.rejected, rejectedHandler);
  },
});

export const { reset } = PermohonanSlice.actions;
export default PermohonanSlice.reducer;
